module.exports = __webpack_public_path__ + "static/media/navegacion.6a8a032d.png";